import React from 'react';
import PropTypes from 'prop-types'
import HeaderSmall from '../components/HeaderSmall';
import Layout from '../layouts/index';
import Gallery from '../components/Gallery';

const GalleryPage = ({ data }) => {

  return (
    <Layout>
        <HeaderSmall siteTitle="Pups N Suds Dog Grooming" />
        <Gallery data={data} />     
    </Layout>
  );
}

GalleryPage.propTypes = {
  data: PropTypes.object,
}

export default GalleryPage;

export const galleryQuery = graphql`
  query ImageQuery {
    allImageSharp {
      edges {
        node {
          ... on ImageSharp {
            sizes(maxWidth: 250, maxHeight: 187, quality: 90) {
              ...GatsbyImageSharpSizes_noBase64
            }
          }
        }
      }
    }
  }
`;